module.exports = __webpack_public_path__ + "static/media/testfile_metacaf.3a48a99c.zip";